import { component as defineComponent } from 'flightjs';
import '@99designs/common/jquery-plugins/modal';

var ndaModal = function() {
    this.attributes({
        agreeForm: '[data-agree-form]',
        listingIdInput: '[data-listing-id-input]',
        agreeToCustomNdaCheckbox: '[data-agree-to-custom-nda]',
        agreeButton: '[data-submit-btn]',
        ndaContent: '[data-nda-content]',
        modalTrigger: '[data-modal-name]',
    });

    this.after('initialize', function() {
        this.on(document, 'dataNdaLoaded', this.showNdaModal);
        this.on(document, 'dataNdaSigned', this.closeNdaModal);
        this.on(document, 'dataNdaSigningFailed', this.handleFailure);

        this.on('click', {
            agreeButton: this.triggerSignNda,
        });
    });

    this.showNdaModal = function(e, data) {
        this.select('ndaContent').html(data.content);
        this.select('listingIdInput').val(data.listingId);
        this.select('agreeForm').attr('action', data.acceptUrl);
        this.select('agreeForm').data('openTriggerId', data.openTriggerId);
        this.select('agreeButton').removeAttr('data-button-disabled');

        if (this.select('modalTrigger').data('modal')) {
            this.select('modalTrigger')
                .data('modal')
                .show();
            $('.classic-modal__inner', this.select('modalTrigger').data('modal').$elem).scrollTop(
                0
            ); // patch Asimov modal
        }
    };

    this.closeNdaModal = function(e, data) {
        if (this.select('modalTrigger').data('modal')) {
            this.select('modalTrigger')
                .data('modal')
                .hide();
        }
    };

    this.handleFailure = function(e, data) {
        this.select('agreeButton').removeAttr('data-button-disabled');
    };

    this.triggerSignNda = function(e) {
        e.preventDefault();
        this.select('agreeButton').attr('data-button-disabled', true);
        this.trigger('uiSignNdaRequested', {
            url: this.select('agreeForm').attr('action'),
            listingId: this.select('listingIdInput').val(),
            agreeToCustomNda: this.select('agreeToCustomNdaCheckbox').prop('checked'),
            openTriggerId: this.select('agreeForm').data('open-trigger-id'),
        });
    };
};

export default defineComponent(ndaModal);



// WEBPACK FOOTER //
// ./src/web/js/browse/ui/nda-modal.js